// Master-Sprint P0 2026-02 — Alert-Center price-change utilities.
// Extracted from AlertBell.jsx so the direction defense can be unit-tested.
// Keep this file free of React imports so it stays trivially importable.

/**
 * Defensive: recompute direction + signed pct from open/close when
 * raw prices are available. Legacy server-side `direction` and
 * `change_pct_signed` are NEVER trusted when raw prices are present —
 * earlier worker builds wrote them wrong for raises. The raw prices
 * are the single source of truth.
 *
 * Returns:
 *   { direction: 'down'|'up'|'flat'|null, pct: number|null }
 *   where `pct` is a signed fraction (e.g. +0.19 for a 19 % raise).
 */
export function priceChangeSummary(d) {
  const open = typeof d?.open_price === "number" ? d.open_price : null;
  const close = typeof d?.close_price === "number" ? d.close_price : null;
  let direction = null;
  let pct = null;
  if (open != null && close != null && open > 0) {
    if (close > open) direction = "up";
    else if (close < open) direction = "down";
    else direction = "flat";
    pct = (close - open) / open;
  } else {
    // Fall back to server-provided fields ONLY when raw prices missing.
    direction = d?.direction || null;
    pct =
      typeof d?.change_pct_signed === "number" ? d.change_pct_signed : null;
  }
  return { direction, pct };
}
